import axios from "axios";
import api from "../api";
import product_service from "./product-service";
import provider_service from "./provider-service";
import store from "@/store";

function create(params = {}) {
  return new Promise((resolve, reject) => {
    product_service.create(params).then(async (product) => {
      store.dispatch("alerts/success", "Estrutura criada com sucesso");
      await createStructureConfigs({ id: product.id, config: params.config })
        .then(async (response) => {
          await provider_service.updateProductSupplier({
            product_id: product.id,
            params: params.suppliers,
          });
          await product_service.createProductDimensions(product.id,params.dimensions);
          resolve({
            structure: response.data,
          });
        })
        .catch((error) => {
          store.dispatch("alerts/success", "Erro ao criar estrutura");
          reject(error);
        });
    });
  });
}

function createStructureConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${params.id}/structure_type`, params.config)
      .then((response) => {
        store.dispatch("alerts/success", "Configurações de estrutura criadas com sucesso");
        resolve(response);
      })
      .catch((error) => {
        store.dispatch("alerts/success", "Erro ao criar configurações de estrutura");
        reject(error);
      });
  });
}

async function read(params = {}, id) {
  return {
    structures: await product_service.getProductByCategoryId({
      ...params,
      url_filter: true,
      url_params: { category: id, ...params.url_params },
    }),
  };
}

async function update(params = {}) {
  return new Promise((resolve, reject) => {
    product_service.update(params).then(async (product) => {
      store.dispatch("alerts/success", "Estrutura editada com sucesso");
      updateStructureConfigs({ id: params.id, config: params.config }).then(
        async (response) => {
          await provider_service.updateProductSupplier({
            product_id: params.id,
            params: params.suppliers,
          });
          await product_service.updateProductDimensions(params.id,params.dimensions);
          resolve();
        }
      );
    });
  });
}

function updateStructureConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${params.id}/structure_type`, params.config)
      .then((response) => {
        store.dispatch("alerts/success", "Configurações de estrutura editadas com sucesso");
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.products}/${id}`)
      .then((response) => {
        resolve({
          data_name: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
};
